import { jsx } from "react/jsx-runtime";
import "react";
import { PropertySearch } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
const PROPERTY_SEARCH_CONFIG_VALUES = {
  test: {
    origin: "https://www.qa.zillow.net",
    graphURL: "https://zg-graph-stage.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/"
  },
  prod: {
    origin: "https://www.zillow.com",
    graphURL: "https://www.zillow.com/graphql/"
  }
};
const BlockPropertySearch = ({
  attrs
}) => {
  const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /* @__PURE__ */ jsx(PropertySearch, { opensInNewWindow: true, propertySearchConfigValues: PROPERTY_SEARCH_CONFIG_VALUES[NEXT_PUBLIC_ENV] || PROPERTY_SEARCH_CONFIG_VALUES.test, ...attrs });
};
BlockPropertySearch.propTypes = {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(["sm", "md", "lg"]),
    categories: PropTypes.arrayOf(PropTypes.oneOf(["buy", "rent", "sell", "zestimate"])),
    t: PropTypes.string,
    opensInNewWindow: PropTypes.bool
  }),
  index: PropTypes.number
};
export {
  PROPERTY_SEARCH_CONFIG_VALUES,
  BlockPropertySearch as default
};
